var map = {
	"./de/actions.js": 435,
	"./de/errors.js": 436,
	"./de/global.js": 437,
	"./de/header.js": 438,
	"./de/labels.js": 439,
	"./de/state.js": 238,
	"./de/success.js": 440,
	"./en/actions.js": 441,
	"./en/errors.js": 442,
	"./en/global.js": 443,
	"./en/header.js": 444,
	"./en/labels.js": 445,
	"./en/state.js": 239,
	"./en/success.js": 446
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 434;


//////////////////
// WEBPACK FOOTER
// ./src/lang \.js$
// module id = 434
// module chunks = 2